import { PublicHomeDto } from '@/server/public-api/types'
import { Locale } from '@/types'
import { buildLocalePath } from '@/utils'
import Resources from '~/@types/resources'

type NavbarItem = {
  title: keyof Resources['common']
  href: string
  isActive?: boolean
  subItems?: NavbarItem[]
}

export const getNavbarItems = (pathname: string, lang: Locale, home?: PublicHomeDto): NavbarItem[] => {
  const librarySubItems: NavbarItem[] = [
    {
      title: 'nav.library_videos' as keyof Resources['common'],
      href: buildLocalePath(lang, '/library/videos'),
      isActive: pathname === '/library/videos' || pathname === `/${lang}/library/videos`,
    },
    {
      title: 'nav.library_blogs' as keyof Resources['common'],
      href: buildLocalePath(lang, '/library/blogs'),
      isActive: pathname === '/library/blogs' || pathname === `/${lang}/library/blogs`,
    },
    {
      title: 'nav.library_books' as keyof Resources['common'],
      href: buildLocalePath(lang, '/library/books'),
      isActive: pathname === '/library/books' || pathname === `/${lang}/library/books`,
    },
  ].filter(item => {
    if (!home) return true
    if (item.href.endsWith('/videos')) return home.videos.length > 0
    if (item.href.endsWith('/blogs')) return home.blogs.length > 0
    return true
  })

  return [
    {
      title: 'nav.home' as keyof Resources['common'],
      href: buildLocalePath(lang, '/'),
      isActive: pathname === '/' || pathname === `/${lang}`,
    },
    {
      title: 'nav.about' as keyof Resources['common'],
      href: buildLocalePath(lang, '/about-us'),
      isActive: pathname === '/about-us' || pathname === `/${lang}/about-us`,
    },
    {
      title: 'nav.courses' as keyof Resources['common'],
      href: buildLocalePath(lang, '/courses'),
      isActive: pathname === '/courses' || pathname === `/${lang}/courses`,
    },
    {
      title: 'nav.pricing' as keyof Resources['common'],
      href: buildLocalePath(lang, '/pricing'),
      isActive: pathname === '/pricing' || pathname === `/${lang}/pricing`,
    },
    {
      title: 'nav.library' as keyof Resources['common'],
      href: '#',
      subItems: librarySubItems,
    },
    {
      title: 'nav.contact' as keyof Resources['common'],
      href: buildLocalePath(lang, '/contact'),
      isActive: pathname === '/contact' || pathname === `/${lang}/contact`,
    },
  ]
}
